import {DocumentMagnifyingGlassIcon} from "@heroicons/react/24/outline";
import {CreditCardPreview} from "../../../../../../../views/DocumentDrawer/components/CreditCardPreview.tsx";
import type {TFICDocument} from "../../../../../../../views/DocumentDrawer/types/Document";

interface CreditCardStatementPreviewPaneProps {
    previewDocument: TFICDocument | null;
    hasSelectedDocument: boolean;
    isPreviewLoading: boolean;
}

export function CreditCardStatementPreviewPane({
    previewDocument,
    hasSelectedDocument,
    isPreviewLoading,
}: CreditCardStatementPreviewPaneProps) {
    if (isPreviewLoading) {
        return (
            <div className="flex h-full min-h-[32rem] flex-col items-center justify-center gap-3 rounded-lg border border-gray-200 bg-white text-center">
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-200 border-t-gray-500" />
                <span className="text-sm text-gray-500">Afschrift laden...</span>
            </div>
        );
    }

    if (hasSelectedDocument && previewDocument) {
        return (
            <div className="flex h-full min-h-[32rem] flex-col">
                <CreditCardPreview document={previewDocument} />
            </div>
        );
    }

    return (
        <div className="flex h-full min-h-[32rem] w-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-white px-8 text-center">
            <DocumentMagnifyingGlassIcon className="mb-4 h-16 w-16 text-gray-400" strokeWidth={1.25} />
            <span className="max-w-xs text-sm text-gray-500">
                Kies links een creditcard afschrift om het voorbeeld te tonen.
            </span>
        </div>
    );
}
